var $l3cx6$react = require("react");
var $l3cx6$reactariautils = require("@react-aria/utils");
var $l3cx6$reactariassr = require("@react-aria/ssr");


function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

$parcel$export(module.exports, "useDisclosure", () => $ef53cd1bcef2de68$export$6e3e27031a30522f);
/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


function $ef53cd1bcef2de68$export$6e3e27031a30522f(props, state, ref) {
    let { isDisabled: isDisabled } = props;
    let triggerId = (0, $l3cx6$reactariautils.useId)();
    let contentId = (0, $l3cx6$reactariautils.useId)();
    let isControlled = props.isExpanded !== undefined;
    let isSSR = (0, $l3cx6$reactariassr.useIsSSR)();
    let supportsBeforeMatch = !isSSR && 'onbeforematch' in document.body;
    // @ts-ignore https://github.com/facebook/react/pull/24741
    (0, $l3cx6$reactariautils.useEvent)(ref, 'beforematch', supportsBeforeMatch && !isControlled ? ()=>state.expand() : null);
    (0, $l3cx6$react.useEffect)(()=>{
        // Until React supports hidden="until-found": https://github.com/facebook/react/pull/24741
        if (supportsBeforeMatch && (ref === null || ref === void 0 ? void 0 : ref.current) && !isControlled && !isDisabled) {
            if (state.isExpanded) ref.current.removeAttribute('hidden');
            else ref.current.setAttribute('hidden', 'until-found');
        }
    }, [
        isControlled,
        ref,
        props.isExpanded,
        state,
        supportsBeforeMatch,
        isDisabled
    ]);
    return {
        buttonProps: {
            id: triggerId,
            'aria-expanded': state.isExpanded,
            'aria-controls': contentId,
            onPress: (e)=>{
                if (!isDisabled && e.pointerType !== 'keyboard') state.toggle();
            },
            isDisabled: isDisabled,
            onKeyDown (e) {
                if (!isDisabled && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    state.toggle();
                }
            }
        },
        panelProps: {
            id: contentId,
            // This can be overridden at the panel element level.
            role: 'group',
            'aria-labelledby': triggerId,
            hidden: !supportsBeforeMatch || isControlled ? !state.isExpanded : true
        }
    };
}


//# sourceMappingURL=useDisclosure.main.js.map
